import { theme } from '@/theme/theme'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Skeleton, Tooltip, Typography, styled } from '@mui/material'
import { FC, ReactNode } from 'react'

const breakAfterFirstWord = (text: string | number): string => {
  if (typeof text !== 'string') return String(text)
  const words = text.split(' ')
  if (words.length <= 1) return text
  return words[0] + '\n' + words.slice(1).join(' ')
}

type BubbleProps = {
  Icon?: IconProp
  LayersIcon?: ReactNode
  main: string | number
  secondary: string | number
  label?: string | number
  tooltip?: string
}

const Bublle: FC<BubbleProps> = ({ Icon, LayersIcon, main, secondary, label, tooltip }) => (
  <OBublleStyled>
    <IBublleStyled>
      <Tooltip title={tooltip || ''} placement="bottom" arrow>
        <ContentBubbleStyled>
          {Icon && <FontAwesomeIcon icon={Icon} fontSize={24} />}
          {LayersIcon}
          <Typography fontSize={24}>
            <Typography fontWeight={theme.typography.fontWeightSemiBold} fontSize="inherit" component="span">
              {main}%
            </Typography>{' '}
            ({secondary})
          </Typography>
          <BubbleLabelStyled>{breakAfterFirstWord(label || '')}</BubbleLabelStyled>
        </ContentBubbleStyled>
      </Tooltip>
    </IBublleStyled>
  </OBublleStyled>
)

export const BubbleLoading: FC = () => (
  <Skeleton
    variant="circular"
    style={{
      height: '15vw',
      maxWidth: '15vw',
      aspectRatio: '1/1',
    }}
  />
)

const OBublleStyled = styled(Box)(() => ({
  aspectRatio: '1/1',
  padding: '2px',
  maxWidth: '15vw',
  height: '15vw',
  border: `1px solid ${theme.palette.deepPurple[200]}`,
  borderRadius: '9999px',
}))

const IBublleStyled = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${theme.palette.cyan[900]}`,
  borderRadius: '9999px',
}))

const ContentBubbleStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
}))

const BubbleLabelStyled = styled(Typography)(() => ({
  whiteSpace: 'pre-line',
  overflowWrap: 'break-word',
  maxWidth: '100%',
  fontSize: '0.875rem',
  lineHeight: 1.2,
  textAlign: 'center',
  padding: 4,
  color: theme.palette.blueDianne[900],
}))

export default Bublle
